"use client";

import { useDPC } from "@/features/global/Events";
import { useEffect } from "react";

export const DepictView = ({
  productId,
}: {
  productId: string | undefined;
}) => {
  const { data: dpc } = useDPC();
  useEffect(() => {
    if (!dpc || !productId) return;

    dpc.setProductId(productId);
  }, [dpc, productId]);
  return null;
};
